<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="批量修改【最高每次点击费用出价】"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap ml20">
            <div class="text-color-error mb20">
                <span v-if="isAll">影响全部 {{totalCnt}} 个关键词</span>
                <span v-else>影响选择的 {{list.length}} 个关键词</span>
            </div>
            <el-form ref="form" :model="formItem" :rules="rules" label-width="30px">
               <div class="radio-item">
                   <el-radio v-model="radioType" label="new" @change="changeRadioType">设置新出价</el-radio>
               </div>
                <el-form-item label="" prop="new_value" v-if="radioType=='new'">
                    <el-input v-model.trim="formItem.new_value" placeholder="请输入金额" @input="(v)=>(formItem.new_value=v.replace(/[^\d.]/g,''))" class="form-input"></el-input>
                </el-form-item>

                <div class="radio-item">
                    <el-radio v-model="radioType" label="plus" @change="changeRadioType">提高出价</el-radio>
                </div>
                <el-form-item label="" prop="plus_value" v-if="radioType=='plus'">
                    <el-input :placeholder="formItem.plusSelect=='number'?'请输入金额':'请输入百分比'" v-model.trim="formItem.plus_value" @input="(v)=>(formItem.plus_value=v.replace(/[^\d.]/g,''))" class="form-input input-with-select">
                        <el-select v-model="formItem.plusSelect" slot="prepend" placeholder="请选择" @change="changePlusSelect">
                            <el-option label="按金额" value="number"></el-option>
                            <el-option label="按百分比" value="rate"></el-option>
                        </el-select>
                        <span slot="append" v-if="formItem.plusSelect=='rate'">%</span>
                    </el-input>
                </el-form-item>
                <div class="radio-item">
                    <el-radio v-model="radioType" label="minus" @change="changeRadioType">降低出价</el-radio>
                </div>
                <el-form-item label="" prop="minus_value" v-if="radioType=='minus'">
                    <el-input :placeholder="formItem.minusSelect=='number'?'请输入金额':'请输入百分比'" v-model.trim="formItem.minus_value" @input="(v)=>(formItem.minus_value=v.replace(/[^\d.]/g,''))" class="form-input input-with-select">
                        <el-select v-model="formItem.minusSelect" slot="prepend" placeholder="请选择" @change="changeMinusSelect">
                            <el-option label="按金额" value="number"></el-option>
                            <el-option label="按百分比" value="rate"></el-option>
                        </el-select>
                        <span slot="append" v-if="formItem.minusSelect=='rate'">%</span>
                    </el-input>
                </el-form-item>
            </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button type="default" @click="handleClose" class="action-btn ml20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">应用</el-button>
        </div>


        <el-dialog
            :title="null"
            :visible.sync="notifyVisible"
            :close-on-click-modal=false
            :close-on-press-escape=false
            :show-close=false
            :destroy-on-close=true
            append-to-body
            width="450px"
            custom-class="apple-dialog-err">
            <div>
                <h5 class="tac font16px">批量修改每日预算请求成功，正在处理…</h5>
                <p class="tac text-color-error pt10 pb20">请勿刷新页面，刷新页面会导致无法及时收到最新结果</p>
            </div>
        </el-dialog>

    </el-dialog>
</template>

<script>
    import API from '@/api/marketManage/apple/index';
    import utils from '@/libs/utils.js';
    import { get_flag_mul_err_html,get_err_info } from "../../components/getFlagHtml.js";

    export default {
        name: "BatchBidAmountModal",
        props:{
            list:Array,
            totalCnt:[Number],
            query:Object,
            isAll:Boolean,
        },
        inject:['priceDecimalConfig'],
        data(){
            let _this = this;
            const validateNewValue = (rule, value, callback)=>{
                if(_this.radioType!='new'){
                    callback();
                }else{
                    let USDConfig = this.decimalConfig.find(item=>item.type=='keyword'&&item.field=='bid_amount'&&item.currency=='USD')||{};
                    let RMBConfig = this.decimalConfig.find(item=>item.type=='keyword'&&item.field=='bid_amount'&&item.currency=='RMB')||{};
                    let limit = this.curCurrency=='美元'?USDConfig.decimal_places:RMBConfig.decimal_places;
                    let reg = limit==3?/^[0-9]\d*(?:\.\d{1,3})?$/:/^[0-9]\d*(?:\.\d{1,2})?$/;
                    if(reg.test(value)&&+value>0){
                        callback();
                    }else{
                        callback(new Error('请输入数值，最多支持'+limit+'位小数'));
                    }
                }
            };
            const validateAddValue = (rule, value, callback)=>{
                if(_this.radioType!='plus'){
                    callback();
                }else{
                    if(_this.formItem.plusSelect=='number'){
                        let USDConfig = this.decimalConfig.find(item=>item.type=='keyword'&&item.field=='bid_amount'&&item.currency=='USD')||{};
                        let RMBConfig = this.decimalConfig.find(item=>item.type=='keyword'&&item.field=='bid_amount'&&item.currency=='RMB')||{};
                        let limit = this.curCurrency=='美元'?USDConfig.decimal_places:RMBConfig.decimal_places;
                        let reg = limit==3?/^[0-9]\d*(?:\.\d{1,3})?$/:/^[0-9]\d*(?:\.\d{1,2})?$/;
                        if(reg.test(value)&&+value>0){
                            callback();
                        }else{
                            callback(new Error('请输入数值，最多支持'+limit+'位小数'));
                        }
                    }else{
                        if(/^[0-9]\d*(?:\.\d{1,2})?$/.test(value)&&+value>0){
                            callback();
                        }else{
                            callback(new Error('请输入数值，最多支持2位小数'));
                        }
                    }
                }
            };
            const validateLessValue = (rule, value, callback)=>{
                if(_this.radioType!='minus'){
                    callback();
                }else{
                    if(_this.formItem.minusSelect=='number'){
                        let USDConfig = this.decimalConfig.find(item=>item.type=='keyword'&&item.field=='bid_amount'&&item.currency=='USD')||{};
                        let RMBConfig = this.decimalConfig.find(item=>item.type=='keyword'&&item.field=='bid_amount'&&item.currency=='RMB')||{};
                        let limit = this.curCurrency=='美元'?USDConfig.decimal_places:RMBConfig.decimal_places;
                        let reg = limit==3?/^[0-9]\d*(?:\.\d{1,3})?$/:/^[0-9]\d*(?:\.\d{1,2})?$/;
                        if(reg.test(value)&&+value>0){
                            callback();
                        }else{
                            callback(new Error('请输入数值，最多支持'+limit+'位小数'));
                        }
                    }else{
                        if(/^[0-9]\d*(?:\.\d{1,2})?$/.test(value)&&+value>0){
                            callback();
                        }else{
                            callback(new Error('请输入数值，最多支持2位小数'));
                        }
                    }
                }
            };

            return {
                dialogVisible:false,
                submitLoading:false,
                radioType:'new',

                formItem:{
                    new_value:'',
                    plus_value:'',
                    minus_value:'',
                    plusSelect:'number',
                    minusSelect:'number',
                },
                rules:{
                    new_value:[
                        { validator: validateNewValue, trigger: 'blur' },
                    ],
                    plus_value:[
                        { validator: validateAddValue, trigger: 'blur' },
                    ],
                    minus_value:[
                        { validator: validateLessValue, trigger: 'blur' },
                    ],
                },


                maxVal:7137,
                notifyTip:null,
                notifyVisible:false,

            }
        },
        computed:{
            decimalConfig(){
                return this.priceDecimalConfig();
            },
            // bid_amount_currency
            curCurrency(){
                let list = this.list||[];
                return (list[0]||{}).bid_amount_currency||'元';
            },
        },
        mounted(){

        },
        methods:{
            handleClose(val){
                console.log('handleClose',val);
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm(){
                this.radioType = 'new';
                this.formItem.new_value = '';
                this.formItem.plus_value = '';
                this.formItem.minus_value = '';
                this.formItem.plusSelect = 'number';
                this.formItem.minusSelect = 'number';
                this.$refs.form.clearValidate();
            },

            handleSubmit(){

                this.$refs.form.validate((valid) => {
                    if (valid) {
                        console.log('handleSubmit');
                        this.notifyVisible = true;
                        this.submitLoading = true;
                        let currency_time = new Date().valueOf();
                        let currentName = `batchBidAmount_${currency_time}`;
                        let keywordIds = (this.list||[]).map(item=>item.keyword_id);
                        if(!this.isAll&&keywordIds.length<=0) return false;
                        if(this.isAll&&this.totalCnt<=0) return this.$message.error('列表暂无数据，无法进行该操作');
                        let reqData = {
                            keyword_id:this.isAll?[]:keywordIds,
                            action_type:this.radioType,
                            new_bid_amount:'',
                            query: this.query,
                            is_all: this.isAll,
                        };
                        reqData.value_type = this.radioType=='new'?'number':this.radioType=='plus'?this.formItem.plusSelect:this.formItem.minusSelect;
                        reqData.new_bid_amount = this.radioType=='new'?this.formItem.new_value:this.radioType=='plus'?this.formItem.plus_value:this.formItem.minus_value;

                        API.editKeywordBidAmount(Object.assign({},reqData,{
                            current_name:currentName,
                        }),{
                            timeout: 120 * 1000,
                        }).then(res=>{
                            console.log('editKeywordBidAmount',res);
                            this.notifyVisible = false;
                            this.submitLoading = false;

                            let resData = res.data||{};
                            let msgText = resData.msg;
                            this.$notify.success({
                                title: resData.info||'操作成功',
                                dangerouslyUseHTMLString: true,
                                message: '<p>'+msgText+'</p>',
                            });
                            this.dialogVisible = false;
                            this.$emit('update');
                            this.resetForm();


                        },err=>{
                            console.log('editKeywordBidAmount err',err);
                            this.notifyVisible = false;
                            this.submitLoading = false;
                            if(err.code =='403'){
                                this.$confirm(err.info, '提示', {
                                    confirmButtonText: '刷新',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                                return
                            }

                            let errData = err.data||{};
                            let {errIds, mulErr, mulexc} = get_err_info(errData.data);

                            let htmlStr=get_flag_mul_err_html(err.info, errData.msg, mulErr, mulexc, currentName, errIds, 'keyword');
                            this.notifyTip = this.$notify({
                                showClose: false,
                                duration: 0,
                                dangerouslyUseHTMLString: true,
                                message: htmlStr,
                                customClass:'width400',
                            });
                            this.$store.commit('apple/ADD_NOTIFY',{
                                id: `${currentName}_close`,
                                value:this.notifyTip,
                            });
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            showModal(){
                this.dialogVisible = true;
            },
            changeRadioType(){
                this.$refs.form.clearValidate();
            },
            changePlusSelect(){
                this.$refs.form.validateField('plus_value');
            },
            changeMinusSelect(){
                this.$refs.form.validateField('minus_value');
            },
        },
    }
</script>

<style lang="scss" scoped>
    .radio-item{
        margin-bottom: 10px;
    }
    .form-input{
        width: 360px;
    }
    .input-with-select ::v-deep .el-input--suffix{
        width: 100px;
    }
</style>
